import React from 'react'
import gql from 'graphql-tag'
import ContentBlock from 'components/ContentBlock'
import Button from 'components/Button'
import { useMutation } from 'components/graphql'
import get from 'lodash/get'
const mutation = gql`
	mutation importFruticoProducts{
		cashAssist {
			importFruticoProducts
	  }
	}
`
const bachmann = 'b3ea332e-9e38-466e-b127-e12499fe8a1b'

const Frutico = ({ appData }) => {
	const [mutate] = useMutation(mutation)
	const companyId = get(appData, 'authData.attributes.custom:company', '')

	if(companyId !== bachmann) {
		return null
	}
	return(
		<ContentBlock label='Frutico'>
			<Button text='Import Frutico Artikel' onClick={mutate}/>
		</ContentBlock>
	)
}

export default Frutico